module.exports = __webpack_public_path__ + "static/media/skype.5eb8a48d.svg";